import axios from 'axios';
import { ReactNode, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { en_US, zh_HK } from '../locales';
import { useAttributeAndQsContext } from './AttributeAndQsContext';

export const DEFAULT_LOCALE = 'zh-hk';

const messages = {
  'zh-hk': zh_HK,
  en: en_US,
};

export const LocaleProvider = ({
  children,
  locale: localeProps,
}: {
  children: ReactNode;
  locale?: string;
}) => {
  const { lang } = useAttributeAndQsContext();

  const locale =
    localeProps ||
    (typeof lang === 'string' && lang in messages ? lang : DEFAULT_LOCALE);

  useEffect(() => {
    axios.defaults.headers.common['Accept-Language'] = locale;
    localStorage.setItem('locale', locale);
  }, [locale]);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};
